import {Button, Modal} from "antd";
import React from "react";
import icon from "../../../assets/images/modal-icon-payment-error.svg";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {UI} from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import "./DailyLimitErrorModal.scss";

interface IProps {
  callback: () => void;
}

const DailyLimitErrorModal = (props: IProps) => {
  
  return (
    <Modal
      className="daily-limit-error-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={false}
      footer={false}
      centered
      destroyOnClose
      onCancel={props.callback}
    >
      <div className="content">
        <img className="icon" src={icon} alt="icon"/>
        <FirebaseKey className="title" firebaseKey={FirebaseService.error_daily_limit_popup_header}/>
        <FirebaseKey className="text" firebaseKey={FirebaseService.error_daily_limit_popup_desc}/>
        <Button
          className="app-button"
          onClick={props.callback}
        >
          <FirebaseKey firebaseKey={FirebaseService.error_daily_limit_popup_button}/>
        </Button>
      </div>
    </Modal>
  );
}

export default DailyLimitErrorModal;
